

































import {Vue, Component, Prop} from 'vue-property-decorator';
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import DefectPicker from "@/view/shared-components/DefectPicker.vue";

@Component({
    components: {DefectPicker}
})

export default class HoldDefectDetails extends Vue {
    @Prop({required: true}) holdTicket!: HoldTicket;
    @Prop({required: true}) type!: String;

    selectDefect(value) {
        this.holdTicket.defect = value;
        this.holdTicket.defectId = value.id;
    }
}
